import { v4 as uuid } from 'uuid';
import { Keys } from '../constants';

export const fetchMachineGuid = () => {
    let machineGuid = localStorage[Keys.MACHINE_KEY];
    if (!machineGuid) {
        machineGuid = uuid();
        localStorage.setItem(Keys.MACHINE_KEY, machineGuid);
    }
    return machineGuid;
};

export const getStorageKeyName = (key, companyId) => {
    return `${key}_${companyId}`;
};

export const getUrlParameterByName = name => {
    const url = window.location.href;

    // eslint-disable-next-line
    name = name.replace(/[\[\]]/g, '\\$&');

    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);

    if (!results || !results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const widgetMetricPage = () => {
    return window.location.pathname;
};

export const widgetMetricSessionGuid = companyId => {
    const now = Math.round(new Date().getTime() / 1000);
    const sessionGuid = localStorage[getStorageKeyName(Keys.SESSION_KEY, companyId)];
    const sessionStart = parseInt(localStorage[getStorageKeyName(Keys.SESSION_START, companyId)], 10);
    const sessionAge = now - (isNaN(sessionStart) ? 0 : sessionStart);
    if (sessionAge < Keys.SESSION_AGE_LIMIT) {
        localStorage.setItem(getStorageKeyName(Keys.SESSION_START, companyId), `${now}`);
    }
    return sessionGuid;
};
